<template>
    <div id="content">
        <div class="container">
            <div id="page-header-fixed">
                <div class="container">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon">
                                <router-link :to="{path: '/'}">
                                    <img src="/themes/web/assets/images/back-to.svg" alt="">
                                </router-link>
                            </li>
                            <li class="active">{{$t('back_to_home')}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mark-lesson" v-if="screen != 'start_test'"></div>
            <div class="card mt-20" style="z-index: 11;overflow: inherit;">
                <div class="card-body" v-if="screen == 'start_test'">
                    <div class="card-content">
                        <div class="placement-container">
                            <div class="d-flex quick-test-box justify-content-center">
                                <img src="/themes/ito/images/icon-placement-test.svg">
                            </div>
                            <div class="quick-test-bottom box-shadow-main d-flex">
                                <div class="box-details-text">
                                    <div class="box-details-text-item">
                                        <div class="title" style="font-size:12px; color:#212121; opacity: 0.6">{{$t('total')}}: </div>
                                        <div style="font-size:16px; color:#212121; white-space: nowrap;">
                                            <b>{{placement_test.total_question}} {{$t('questions')}}</b>
                                        </div>
                                    </div>
                                    <div class="box-details-text-item">
                                        <div class="title" style="font-size:12px; color:#212121; opacity: 0.6">{{$t('time_allowance')}} </div>
                                        <div style="font-size:16px; color:#212121; white-space: nowrap;">
                                            <b>{{placement_test.time}} {{$t('minutes')}}</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="demand">
                                    <div class="demand-details">
                                        <p style="font-size:16px; color:#212121; margin-bottom: 8px;" ><b>{{$t('request')}}</b></p>
                                        <p style="font-size:12px; color:#20AFFF">{{$t('desc_test')}} {{placement_test.condition_pass}} {{placement_test.type_pass == 'percent'?'%':$t(placement_test.type_pass)}}
                                        </p>
                                    </div>
                                    <div class="cricle-pass">
                                        <p style="font-size:14px; color:#ffffff">{{$t('pass')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="lisa-btn-small active btn-test"
                                 @click="placementTest">
                                 <p>{{$t('start')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'test'" style="padding: 0 !important;">
                    <div class="card-content" style="height: calc(100vh - 285px); padding: 0;min-height: 550px;">
                        <iframe :src="item.content"
                                frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {getFinalTest, startFinalTest, resultFinalTest} from "../../models/final_test";


    export default {
        name: "FinalTest",
        title: 'Final test',
        props: [
            'user_info'
        ],
        data() {
            return {
                test_id: '',
                isLoading: false,
                item: {},
                screen: 'start_test',
                placement_test: ''
            };
        },
      computed: {
        user() {
          return this.$store.state.user_info;
        },
      },

        created() {
            const {item_id} = this.$route.params;
            this.test_id = item_id;
            this.getPlacementItem()
        },
        mounted() {
            window.addEventListener('message', this.handleMessage)
        },
        beforeDestroy() {
            window.removeEventListener('message', this.handleMessage)
        },
        methods: {
            getPlacementItem() {
                const that = this;

                const {item_id, subject_id} = that.$route.params;

                that.isLoading = true;

                getFinalTest({
                    grade_id: item_id,
                    subject_id: subject_id,
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        return;
                    }

                    this.placement_test = response.data.results[0] || {};

                    console.log(this.placement_test)

                    $('#updateGradeModal').modal("hide");
                    // $('#testPlacementModal').modal();
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            },
            placementTest() {
                const that = this;

                // that.getSoundClick();

                that.$store.commit("setLoading", true);

                startFinalTest({
                    id: this.placement_test.id,
                    lang: localStorage.getItem('lang')
                }).then((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        return;
                    }
                    that.item = response.data.results;
                    that.screen = 'test';
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            },
            async handleMessage(event) {
                switch (event.data.action) {
                    case 'test_done':
                        await axios.all([
                            resultFinalTest({
                                id: this.placement_test.id,
                            }),
                        ]).then(axios.spread((response) => {
                            console.log(response);
                            if (response.data.code != 0) {
                                return;
                            }
                            if(response.data.results.pass_test == 1){
                                localStorage.setItem('grade', response.data.results.grade);
                            }
                        }));
                        break;
                    case 'test_close':
                        window.location.href = '/';
                        break;

                }
            },
        }
    }
</script>

<style scoped>
    #page-header .breadcrumb {
        margin-bottom: 0;
    }

    .quick-test-bottom-text {
        width: 100%;
    }

    .quick-test-bottom{
        margin-top: 40px;
        background: #A9E0FF;
        border-radius: 4px;
        padding: 24px 60px;
        display: flex;
        justify-content: center; 
    }

    .lesson-action-button span {
        display: block;
        width: 26px;
        height: 26px;
        margin: 13px auto;
        background: #ffffff;
        text-align: center;
        color: #f04821;
        font-size: 26px;
        line-height: 26px;
        font-weight: bold;
        border-radius: 100%;
        transform: rotate(45deg);
    }

    .mark-lesson {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        left: 0;
        right: 0;
        top: 0;
        z-index: 10;
    }

    .modal-sm {
        max-width: 400px;
    }

    .ito-icon-close {
        position: absolute;
        right: 18px;
    }

    .next-item-modal {
        background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
        border-radius: 20px;
        box-shadow: 4px 4px 0px 0px #00000012;
        border: none;
        padding: 5px 10px;
        color: #fff;
        margin-top: 10px;
    }

    .box-result-popup {
        padding: 7px 15px;
    }

    .container{
        padding: 0;
        margin-top: 20px;
    }

    .btn-test{
        margin: auto;
        margin-top: 30px;
        font-size: 12px;
        width: 136px;
        height: 40px;
        display: flex;
        justify-content: center;
    }
    .btn-test p{
        margin: 0;
        line-height: 40px;
    }
    .card-body{
        /* padding: 0; */
        border-radius: 16px;
        padding: 48px 172px 80px;
        box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }
    .card{
        border-radius: 16px;
    }
    .demand{
        background: #FBFEFF;
        border-radius: 4px;
        padding: 12px 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .demand .demand-details{
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
    }
    .demand .demand-details p{
        margin: 0;
    }
    .demand .cricle-pass{
        width: 44px;
        height: 44px;
        background: #1CB7A4;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
    }
    .demand .cricle-pass p{
        margin: 0;
    }
    .box-details-text .box-details-text-item{
        display: flex;
    }
    .box-details-text .box-details-text-item .title{
        min-width: 100px;
        display: flex;
        justify-content: flex-end;
        margin-right: 8px;
    }
    .box-details-text .box-details-text-item:nth-child(1){
        margin-bottom: 15px;
    }
    .box-details-text{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-right: 40px;
        /* padding: 12px 28px; */
    }
    @media (max-width: 1200px) {
        .card-body{
            padding: 30px 50px 40px;
        }
    }
</style>